import React from 'react'
import ConfigureContext from '../configure-context'
import ConfigureDiscussionModal from '../configure-modal'
import { get } from 'lodash'

const DiscussionConfigurationProvider = ({ children }) => {
    const [discussion, setDiscussion] = React.useState()

    const configureDiscussion = React.useCallback(({ topic, users }) => {
        setDiscussion({ topic, users})
    }, [setDiscussion])

    const renderConfiguration = () => {
        if (!discussion) {
            return null
        }
        return (
            <ConfigureDiscussionModal
                users={get(discussion, 'users', [])}
                topic={get(discussion, 'topic', '')}
                onClose={() => setDiscussion()}
            />
        )
    }

    return (
        <ConfigureContext.Provider value={{ configureDiscussion }}>
            {children}
            {renderConfiguration()}
        </ConfigureContext.Provider>
    )
}

export default DiscussionConfigurationProvider
